// https://github.com/facebook/draft-js/blob/c9aaa547e2a6a7efaa82c634218883eecb018c38/examples/draft-0-10-0/rich/rich.html
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Editor, EditorState, RichUtils } from 'draft-js';
import draftjsStyle from 'draft-js/dist/Draft.css';
import style from './RichEditor.css';

class RichEditor extends React.Component {
  constructor(props) {
    super(props);
    this.focus = () => this.editor.focus();
    this.onChange = props.onChange;
    this.handleKeyCommand = this._handleKeyCommand.bind(this);
    this.onTab = this._onTab.bind(this);
    this.toggleBlockType = this._toggleBlockType.bind(this);
    this.toggleInlineStyle = this._toggleInlineStyle.bind(this);
  }
  _handleKeyCommand(command, editorState) {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onChange(newState);
      return true;
    }
    return false;
  }
  _onTab(e) {
    const maxDepth = 4;
    this.onChange(RichUtils.onTab(e, this.props.editorState, maxDepth));
  }
  _toggleBlockType(blockType) {
    this.onChange(RichUtils.toggleBlockType(this.props.editorState, blockType));
  }
  _toggleInlineStyle(inlineStyle) {
    this.onChange(
      RichUtils.toggleInlineStyle(this.props.editorState, inlineStyle)
    );
  }
  render() {
    const { editorState } = this.props;
    // If the user changes block type before entering any text, we can
    // either style the placeholder or hide it. Let's just hide it now.
    let className = 'RichEditor-editor';
    const contentState = editorState.getCurrentContent();
    if (!contentState.hasText()) {
      if (
        contentState
          .getBlockMap()
          .first()
          .getType() !== 'unstyled'
      ) {
        className += ' RichEditor-hidePlaceholder';
      }
    }
    return (
      <div className="RichEditor-root">
        <div className="row">
          <InlineStyleControls
            editorState={editorState}
            onToggle={this.toggleInlineStyle}
          />
          <BlockStyleControls
            editorState={editorState}
            onToggle={this.toggleBlockType}
          />
        </div>
        <div className={className} onClick={this.focus}>
          <Editor
            editorKey="foo"
            blockStyleFn={getBlockStyle}
            customStyleMap={styleMap}
            editorState={editorState}
            handleKeyCommand={this.handleKeyCommand}
            onChange={this.onChange}
            onTab={this.onTab}
            placeholder={this.props.placeholder}
            ref={editor => {
              this.editor = editor;
            }}
            spellCheck
          />
        </div>
      </div>
    );
  }
}
// Custom overrides for "code" style.
const styleMap = {
  CODE: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    padding: 2
  }
};
function getBlockStyle(block) {
  switch (block.getType()) {
    case 'blockquote':
      return 'RichEditor-blockquote';
    default:
      return null;
  }
}
class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = e => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }
  render() {
    let className = 'RichEditor-styleButton';
    if (this.props.active) {
      className += ' RichEditor-activeButton';
    }
    return (
      <span className={className} onMouseDown={this.onToggle}>
        {this.props.label}
      </span>
    );
  }
}
const BLOCK_TYPES = [
  {
    label: (
      <i
        title="underline"
        data-toggle="tooltip"
        aria-hidden="true"
        className="fa fa-list"
      />
    ),
    style: 'unordered-list-item'
  },
  {
    label: (
      <i
        title="underline"
        data-toggle="tooltip"
        aria-hidden="true"
        className="fa fa-list-ol"
      />
    ),
    style: 'ordered-list-item'
  }
];
const BlockStyleControls = props => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();
  return (
    <span className="RichEditor-controls">
      {BLOCK_TYPES.map(type => (
        <StyleButton
          key={type.style}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </span>
  );
};
const INLINE_STYLES = [
  {
    label: (
      <i
        title="bold"
        data-toggle="tooltip"
        aria-hidden="true"
        className="fa fa-bold"
      />
    ),
    style: 'BOLD'
  },
  {
    label: (
      <i
        title="italic"
        data-toggle="tooltip"
        aria-hidden="true"
        className="fa fa-italic"
      />
    ),
    style: 'ITALIC'
  },
  {
    label: (
      <i
        title="underline"
        data-toggle="tooltip"
        aria-hidden="true"
        className="fa fa-underline"
      />
    ),
    style: 'UNDERLINE'
  }
];
const InlineStyleControls = props => {
  const currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <span className="RichEditor-controls ml-2">
      {INLINE_STYLES.map(type => (
        <StyleButton
          key={type.style}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </span>
  );
};

export default withStyles(draftjsStyle, style)(RichEditor);



// WEBPACK FOOTER //
// ./src/components/RichEditor/RichEditor.js